import { Swiper, SwiperSlide } from 'swiper/react';
import { useRef } from 'react';

import 'swiper/css';
import Card from './card';
import ArrowSmallLeftIcon from '../../../assets/arrow-small-left-icon';
import ArrowSmallRightIcon from '../../../assets/arrow-small-right-icon';

const CardSwiper = ({ data, slidesPerView }) => {
  const swiperRef = useRef();

  return (
    <div className="w-full flex justify-between items-center space-x-5">
      <button className="" onClick={() => swiperRef.current?.slidePrev()}>
        <ArrowSmallLeftIcon />
      </button>
      <Swiper
        spaceBetween={30}
        slidesPerView={slidesPerView}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {data?.map((service, idx) => (
          <SwiperSlide>
            <Card
              title={service?.name}
              subtitle={service?.description}
              type={service?.mnemonic}
              key={idx}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <button className="" onClick={() => swiperRef.current?.slideNext()}>
        <ArrowSmallRightIcon />
      </button>
    </div>
  );
};

export default CardSwiper;
